import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { MODAL_TYPE_PDF_VIEW_IMAGE } from '../../../../actions/ModalActions';
import { propChildren } from '../../../../helpers/custom-prop-types';
import Modal from '../index';
import PdfImageModalContent from './PdfImageModalContent';
const PdfImageModal = ({ children }) => (_jsx(Modal, Object.assign({ hideRemove: true, isWide: true, modalClassName: 'pdf-image-modal', modalType: MODAL_TYPE_PDF_VIEW_IMAGE, propHide: false }, { children: _jsx(PdfImageModalContent, { customChildren: children }) })));
PdfImageModal.propTypes = {
    children: propChildren(),
};
PdfImageModal.defaultProps = {
    children: undefined,
};
export default PdfImageModal;
